<template>
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.001 12a1 1 0 1 0 0 1.999H18.001a1 1 0 0 0 1-1V8a1 1 0 0 0-2 0v2.403C15.296 8.33 12.664 7.001 9.71 7.001 5.8 7 2.456 9.329 1.076 12.625a.989.989 0 0 0 .57 1.302c.53.207 1.133-.04 1.348-.552C4.069 10.808 6.672 9 9.71 9c2.46 0 4.634 1.186 5.944 3H13Z" />
    </svg>
</template>
